import {
  IPackingList,
  ISearchPackingListReq,
  ISearchPackingListRes,
} from '../interfaces/packingList';
import * as baseAdapter from './baseAdapter';

export const querypackingLists = async () => {
  const ret = await baseAdapter.get<IPackingList[]>('/packingList');
  return ret;
};

export const querypackingList = async (id: number) => {
  const ret = await baseAdapter.get<IPackingList>(`/packingList/get/${id}`);
  return ret?.data;
};

export const searchpackingLists = async (req: ISearchPackingListReq) => {
  const ret = await baseAdapter.post<ISearchPackingListRes>(
    '/packingList/gets',
    req,
  );
  return ret;
};

export const addpackingList = async (data: Partial<IPackingList>) => {
  const ret = await baseAdapter.post('/packingList/create', data);
  return ret;
};

export const editpackingList = async (data: Partial<IPackingList>) => {
  const ret = await baseAdapter.put(`/packingList/update/${data.id}`, data);
  return ret;
};

export const deletepackingList = async (id: number) => {
  const ret = await baseAdapter.deleteRequest(`/packingList/delete/${id}`);
  return ret;
};
